export default {
    name: "Ogólne",
    key: "Var_General",
    variables: [
        "bgColor",
        "bgColorFont",
        "primaryColor",
        "primaryColorFont",
        "secondaryColor",
        "secondaryColorFont",
        "lightestColor",
        "lightestColorFont",
        "lighterColor",
        "lighterColorFont",
        "middleColor",
        "middleColorFont",
        "iconColors",
        "iconColorsHover",
        "lightBorderColor",
        "menuBackgroundColor",
        "menuBorderColor",
        "menuIconsAndFontColor",
        "menuIconsAndFontColorHover",
        "inputsBgColor",
        "formsBgColor",
        "footerColorBackground",
        "footerColorFont",
        "footerColorLinks",
        "footerBannerBackground",
        "btnSolidBgColor",
        "btnSolidTextColor",
        "hoverOverButton",
        "btnSolidHoverTextColor",
        "secondaryBtnBgColor",
        "secondaryBtnFontColor",
        "secondaryBtnBorderColor",
        "secondaryBtnHoverBgColor",
        "secondaryBtnHoverFontColor",
        "secondaryBtnHoverBorderColor",
        "fontColorGreyBar",
        "iconColorGreyBar",
        "colorBackgroundLogo",
        "activeListIconBackgroundColor",
        "activeListIconColor",
        "inactiveListIconColor",
        "focusVisibleColor"
    ]
}